import { AtsRecordTypeEnum } from '@vangst/services/oogst/types'
import useViewer from '@vangst/services/oogst/viewer/useViewer'
import { useMemo } from 'react'
import { MdDescription, MdError, MdHistory } from 'react-icons/md'
import AlertText from '../../components/feedback/AlertText'
import GroupHeader from '../../components/views/GroupHeader'
// import CompanyAllApplications from './CompanyAllApplications'
import CompanyJobPostingsRenderer from './CompanyJobPostingsRenderer'

export default function CompanyDashboardSections() {
  const { viewer } = useViewer()

  const vars = useMemo(
    () => ({
      companyAtsFree: {
        displayname: viewer?.nameOrId ?? '',
        atsRecordType: AtsRecordTypeEnum.PlatformFree,
        first: 6,
      },
      companyFollowers: { displayname: viewer?.nameOrId ?? '', first: 24 },
      companyProfilePending: viewer?.client?.permissions?.readPendingBanner,
      searchCandidatesByClients: { first: 3 },
      searchCandidates: { first: 3 },
    }),
    [viewer],
  )

  return (
    <>
      {vars.companyProfilePending && (
        <section className="flow-y-sm grid gap-4">
          <div className="flex items-center text-orange heading-md">
            <MdHistory className="mr-4 " />
            <span>Your Company Profile Is Pending</span>
          </div>
          <span>
            Your company account needs to be approved before you can publish any
            job postings.
          </span>
        </section>
      )}

      <section>
        <GroupHeader
          className="items-center justify-between"
          icon={MdDescription}
          title={
            vars.companyProfilePending
              ? 'Unpublished Job Postings'
              : 'My Job Postings'
          }
          to={
            viewer?.client?.routes ? viewer?.client?.routes?.jobPostings : '#'
          }
          toLabel={`View ${
            vars.companyProfilePending
              ? 'All Unpublished Jobs'
              : 'All Job Postings'
          }`}
        ></GroupHeader>
        {vars.companyProfilePending && (
          <AlertText className="text-sm italic" icon={MdError}>
            Jobs will be visible to the Vangst network once your account has
            been approved.
          </AlertText>
        )}
        <div className="mt-4">
          <CompanyJobPostingsRenderer
            as="card"
            at="preview"
            classNameList="grid-three-up"
            take={3}
            variables={vars.companyAtsFree}
          />
        </div>
      </section>
      {/* <section>
        <GroupHeader
          className="items-center justify-between"
          icon={MdDescription}
          title="Applications"
        ></GroupHeader>
        {viewer?.client && (
          <CompanyAllApplications
            as="slip"
            at="sidebar"
            take={4}
            displayname={viewer?.client?.displayname}
            variables={{ displayname: viewer.client.displayname }}
          />
        )}
      </section> */}
    </>
  )
}
